import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteMatchListGroupPayload } from '@app-store/slices/matchListGroups/delete'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IDeleteMatchListGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchListGroups.delete

function* deleteMatchListGroupSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete(`/companies/match-list-groups/${payload.matchListGroupId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Match list group deleted successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteMatchListGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteMatchListGroupSagaTask)
}

export default deleteMatchListGroupSaga
